module.exports = __webpack_public_path__ + "static/og-image-homepage-22a3bc4100359940a668404eebba2291.png";